import { actionTypes, getMessagesHistory } from "../../store";
import { MessageTypes } from "../../lib/types";
import { deepChange } from "../../actions";
import { converstationHistoryKey } from "../../lib/constants";

/**
 * Prevent user from editing the interactive messages once the lead is submitted.
 * @returns {Function}
 */
export const makeMessagesUneditable = () => (dispatch, getState) => {
  const state = getState();
  const messagesHistory = getMessagesHistory(state);
  messagesHistory.forEach((message, messageNum) => {
    if (message.type === MessageTypes.INTERACTIVE_USER_MESSAGE) {
      dispatch(
        deepChange({
          path: ["messagesHistory", messageNum, "submitted"],
          value: true,
        })
      );
    }
  });
};
/**
 * Set user input error message.
 */
export const setErrorMessage = (messageNum, errorMessage) => (dispatch) => {
  dispatch(deepChange({ path: `inputErrors.${messageNum}`, value: errorMessage }));
};
/**
 * Change user input value.
 */
export const changeTextInput = (textInputValue) => (dispatch) => {
  dispatch(deepChange({ textInputValue }));
};
/**
 * Sets a flag which tells:
 * Is user answering the last message or editing an older message.
 */
export const setIfWorkingWithHistory = (workWithHistory) => (dispatch) => {
  dispatch(deepChange({ workWithHistory }));
};
/**
 * Set the number of the message which user is editing.
 */
export const changeEditingMessage = (editingMessageNum) => (dispatch) => {
  dispatch(deepChange({ editingMessageNum }));
};
/**
 * Store/update an answer for the message by the message index.
 * There is a small issue here - the local storage is updated only if the answer received is for
 * the latest stored message. But since the local storage might contain messages for the previous
 * session as well - it will be hard to fix that and not very important, so this is left as it is.
 */
export const setMessageAnswer = ({ messageNum, answer } = {}) => (dispatch, getState) => {
  const state = getState();
  dispatch({
    type: actionTypes.SET_MESSAGE_ANSWER,
    payload: { messageNum, answer },
  });

  // Update the answer in the localStorage as well. Wtf? I don't remember the purpose of this.
  if (messageNum === state.messagesHistory.length - 1) {
    const messages = JSON.parse(localStorage.getItem(converstationHistoryKey) || "[]");
    messages.slice(-1)[0].answer = answer;
    localStorage.setItem(converstationHistoryKey, JSON.stringify(messages));
  }
};
/**
 * Main handler to add new message to the chat/store/history.
 */
export const addMessage = (message) => (dispatch) => {
  message.timestamp = new Date().getTime();
  addMessageToLocalStorage(message);
  dispatch({
    type: actionTypes.STORE_MESSAGE,
    payload: message,
  });
};
/**
 * Add new message to the local storage.
 */
export const addMessageToLocalStorage = (message) => {
  let messages = JSON.parse(localStorage.getItem(converstationHistoryKey) || "[]");
  messages = [...messages, message];
  localStorage.setItem(converstationHistoryKey, JSON.stringify(messages));
};
